import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../components/Grid.jsx';
import Select from '../components/Select.jsx';
import InputLabel from '../components/InputLabel.jsx';
import FormControl from '../components/FormControl.jsx';
import FormHelperText from '../components/FormHelperText.jsx';
import useUniqueId from '../hooks/useUniqueId.js';
import formatError from '../utils/formatError.jsx';

const GridSelect = ({gridProps, ...props}) => {
  const {error, id, label} = props;
  const helperTextId = useUniqueId();
  const selectId = useUniqueId();
  const finalSelectId = id || selectId;
  return (
    <Grid item {...gridProps}>
      <FormControl variant={'outlined'} fullWidth error={!!error}>
        <InputLabel
          htmlFor={finalSelectId}
          variant={'outlined'}
          error={!!error}>
          {label}
        </InputLabel>
        <Select {...props} id={finalSelectId} aria-describedby={helperTextId} />
        {
          !!error && (
            <FormHelperText
              id={helperTextId}
              role="alert"
              aria-label={formatError(error)}
            >
              {formatError( error)}
            </FormHelperText>
          )
        }
      </FormControl>
    </Grid>
  );
};

GridSelect.propTypes = {
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  gridProps: PropTypes.object.isRequired,
  error: PropTypes.object,
};

export default GridSelect;
